import React from 'react';
import PropTypes from 'prop-types';
import VehicleImage from 'components/VehicleImage';

import { DetailCell } from './styled';

// const t = {
//   meters: 'm'
// };

const VehicleType = ({ vehicle_type, container_length, ...props }) => (
  <DetailCell {...props}>
    <VehicleImage type={vehicle_type} className="vehicle-icon" />
    {/* {!!container_length && container_length > 0 && (
      <div>
        {container_length} {t.meters}
      </div>
    )} */}
  </DetailCell>
);

VehicleType.propTypes = {
  vehicle_type: PropTypes.string,
  container_length: PropTypes.string,
};

export default VehicleType;
